export default "__VITE_ASSET__TyPOjj0W__"